// src/auth.js — MySQL-backed auth via server API
const SESSION_KEY = "nx_session_v2";
const TOKEN_KEY   = "nx_token_v2";

export function getSession() {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY) || "null"); } catch { return null; }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

function saveSession(user, token) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(user));
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

export async function signUp({ name, email, password }) {
  try {
    const res = await fetch("/api/auth/signup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, password }),
    });
    const data = await res.json();
    if (!res.ok) return { error: data.error || "Signup failed" };
    saveSession(data.user, data.token);
    return { user: data.user, needsVerification: !!data.needsVerification };
  } catch(e) {
    return { error: "Server not reachable. Make sure the server is running." };
  }
}

export async function signIn({ email, password }) {
  try {
    const res = await fetch("/api/auth/signin", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) return { error: data.error || "Login failed" };
    saveSession(data.user, data.token);
    return { user: data.user };
  } catch(e) {
    return { error: "Server not reachable. Make sure the server is running." };
  }
}

export async function signOut() {
  const token = getToken();
  if (token) {
    fetch("/api/auth/signout", {
      method: "POST",
      headers: { "x-session-token": token },
    }).catch(() => {});
  }
  clearSession();
}

export async function validateSession() {
  const token = getToken();
  if (!token) return null;
  try {
    const res = await fetch("/api/auth/me", {
      headers: { "x-session-token": token },
    });
    if (!res.ok) { clearSession(); return null; }
    const data = await res.json();
    // Refresh stored session with latest plan info
    localStorage.setItem(SESSION_KEY, JSON.stringify(data.user));
    return data.user;
  } catch { return getSession(); } // fallback to cached session
}
